import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  apiUrl: string = environment.API_SERVER;
  
  constructor(private _httpClient: HttpClient) {}


  getAllUsers(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/users`, {
      params: payload.params,
    });
  }

  uploadFile(payload):Observable<any> {
    return this._httpClient.post(`${this.apiUrl}/files`, 
      payload.body
    );
  }
  getFileTemporarily(payload){
    return this._httpClient.get(`${this.apiUrl}/files?fileKey=${payload.fileKey}`, {})

  }

  getUser(payload): Observable<any> {
    return this._httpClient.get(`${this.apiUrl}/users/me`);
  }

  updateUser(payload): Observable<any> {
    return this._httpClient.patch(
      `${this.apiUrl}/users/me`,
      payload.body
    );
  }

  updatePassword(payload): Observable<any> {
    return this._httpClient.patch(
      `${this.apiUrl}/users/me/update-password`,
      payload.body
    );
  }
  
}
